const SESSION_KEY = "aletheia_active_session_id";

/** Persists the active session id so a refresh resumes instead of restarting. */
export const quizStorage = {
  getSessionId(): string | null {
    try {
      return localStorage.getItem(SESSION_KEY);
    } catch {
      return null;
    }
  },
  setSessionId(id: string): void {
    try {
      localStorage.setItem(SESSION_KEY, id);
    } catch {
      // ignore — non-critical convenience persistence
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(SESSION_KEY);
    } catch {
      // ignore
    }
  },
};
